import { useState } from "react";

export function useToggle(initialValue: boolean) {
    const [value, setValue] = useState(initialValue);

    const toggleValue = () => {
        setValue((currentValue) => !currentValue);
    };

    const setToggleValue = (value: boolean) => {
        setValue(value);
    };

    return {
        value,
        toggleValue,
        setToggleValue
    };
}
